import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
// import { logger } from "redux-logger";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./store/reducer";
import history from "./history";
import { setInterceptorStore } from "./utilities/setupFetchInterceptor";
import "./styles.css";
import "./components/Modal/modal.css";
export const store = createStore(rootReducer, applyMiddleware(thunk));
setInterceptorStore(store);

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");
// console.log = console.warn = console.error = () => {};
ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App history={history} />
    </Router>
  </Provider>,
  rootElement
);

registerServiceWorker();
